module.exports = __webpack_public_path__ + "static/media/mile1.49ffc58f.png";